export default {
  brewery: 'HorusCrownedEagle',
  info_url: 'http://landing.tavour.com/HorusCrownedEagle/',
  title: {
    in_progress: '',
    success: 'You Joined Horus Aged Ales Crowned Eagle Club! ',
    subtext: 'Join Horus Aged Ales Crowned Eagle Club. ',
    sub_subtext: 'This 12-bottle membership focuses on experimental brews. ' +
      'Six unique skus shipped in June for $560 (includes shipping).',
  },
  review: {
    summary: [
      'You are joining Horus Aged Ales Crowned Eagle Club. ',
      'By signing up your card will be charged $540 per release (shipping included). ' +
      'Each June, we\'ll send you a total of 12 bottles, 6 different experimental brews. ' +
      'You will have the option to opt out by emailing support@tavour.com. ' +
      'You will receive a notification when your box has been charged and shipped. ',
    ],
    button_text: 'Join the Crowned Eagle Club!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/horusCrownedEagle.js